module.exports = __webpack_public_path__ + "img/bucao.70f29e15.png";